import React, { useState, useEffect } from 'react';
import { FaClock, } from 'react-icons/fa';
import { CgFileDocument } from "react-icons/cg";
import './PatientAssessment.css';
import { useLocation } from 'react-router-dom';
import { APIURL } from '../../../Global';
import axios from "axios";
import { LuActivity, LuBone, LuBrain } from "react-icons/lu";
import DocumentPopup from './DocumentPopup.js';

const ScaleDashboard = ({ patientData, therapy_id }) => {
  const location = useLocation()
  const [selected, setSelected] = useState('')
  const [selectedDoc, setSelectedDoc] = useState(null)
  const [scores, setScores] = useState([])
  const [loading, setLoading] = useState(false)
  sessionStorage.setItem('previousPath', '/tilt');

  useEffect(() => {
    fetchScores()
  }, [])

  const fetchScores = async () => {
    setLoading(true);
    const tokenString = sessionStorage.getItem("usertoken");
    let str = tokenString.replace(/["]+/g, "");

    try {
      const response = await axios.get(`${APIURL}/api/v1/patient/therapy-scale/?patient_id=${patientData.id}&therapy_consultation=${patientData.therapy_id}&recordings=score_scale`, {
        headers: {
          Authorization: "Token " + str,
        },
      });

      if (response.data.status === "success") {
        setScores(response.data.message || []);
      } else {
        setScores([]);
      }
    } catch (error) {
      console.error("Error fetching scores:", error);
      setScores([]);
    } finally {
      setLoading(false);
    }
  };

  const assessments = [
    {
      id: 1,
      type: 'ss_scale',
      displayName: 'Scandinavian Stroke Scale',
      icon: LuActivity,
      iconClass: 'icon-general'
    },
    {
      id: 2,
      type: 'asia_scale',
      displayName: 'ASIA',
      icon: LuBone,
      iconClass: 'icon-ortho'
    },
    {
      id: 3,
      type: 'gg_scale',
      displayName: 'Glasgow',
      icon: LuBrain,
      iconClass: 'icon-neuro'
    }
  ];

  // Get available assessments based on existing scores
  const getAvailableAssessments = () => {
    return assessments.filter(assessment =>
      scores.some(score => score.score_scale === assessment.type)
    );
  };

  // Get score data for a specific assessment type
  const getScoreForAssessment = (assessmentType) => {
    return scores.find(score => score.score_scale === assessmentType);
  };

  const CircularText = ({ text }) => {
    return (
      <div className="text">
        <div className={`text-background${patientData?.inpatient ? ' text-background2' : ' text-background1'}`}></div>
        <p>
          {text?.split('').map((char, i) => (
            <span
              key={i}
              style={{
                fontSize: '10px',
                fontWeight: 'bold',
                transform: `rotate(${i * (180 / text.length) + (80 - i * 36)}deg)`,
                position: 'absolute',
                left: '50%',
                bottom: '0',
                transformOrigin: '0 0',
                height: '40px',
                color: 'white'
              }}
            >
              {char}
            </span>
          ))}
        </p>
      </div>
    );
  };

  const hasDocument = (score) => {
    return score.scale_document && score.scale_document !== '{}';
  };

  const getDocumentInfo = (score) => {
    if (!hasDocument(score)) return null;
    try {
      return JSON.parse(score.scale_document);
    } catch (e) {
      return null;
    }
  };

  const handleAssessmentClick = (assessmentType) => {
    const scoreData = getScoreForAssessment(assessmentType);
    if (selected === assessmentType) {
      setSelected('');
      setSelectedDoc(null);
    } else {
      setSelected(assessmentType);
      setSelectedDoc(scoreData);
    }
  };

  const availableAssessments = getAvailableAssessments();

  return (
    <div className="history-view">
      <div className="assessment-section col-3">
        <div className="section-title">
          <FaClock className="header-icon" />
          <h2>Score History</h2>
        </div>

        {loading ? (
          <div className="loading">Loading assessments...</div>
        ) : availableAssessments.length > 0 ? (
          <div className='assessments-list'>
            {availableAssessments.map((assessment) => {
              const IconComponent = assessment.icon;
              const scoreData = getScoreForAssessment(assessment.type);

              return (
                <div
                  key={assessment.id}
                  onClick={() => handleAssessmentClick(assessment.type)}
                  className={`assessment-item ${selected === assessment.type ? 'selected' : ''}`}
                >
                  <div className="assessment-content">
                    <div className={`icon-container ${assessment.iconClass}`}>
                      <IconComponent className="assessment-icon" />
                    </div>
                    <div className="assessment-details">
                      <h3>{assessment.displayName}</h3>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <div className="empty-message">Unable to load or No assessment scores found</div>
        )}
      </div>

      <div className="assessment-details-section col-9">
        <div className="details-container">
          {selectedDoc ? (
            <DocumentPopup
              id={patientData.id}
              type={selected}
              document={selectedDoc}
              displayMode='inline'
            />
          ) : (
            <div className="empty-selection">
              <p className="empty-title">Select to view details</p>
              <p className="empty-subtitle">Choose from the available list on the left</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ScaleDashboard;